<script>
  import { Button } from "$lib/components/ui/button/index.js";
  import Minus from "@lucide/svelte/icons/minus";
  import Plus from "@lucide/svelte/icons/plus";
  import Trash2 from "@lucide/svelte/icons/trash-2";
  import { cart } from "$lib/cart-store.svelte.js";

  let { item = $bindable({}) } = $props();

  let isUnitOne = $derived(item.units === 1);
  let itemUnits = $derived(item.units);

  function handleDecreaseClick() {
    if (item.units === 1) {
      cart.actions.removeItem(item);
    } else {
      cart.actions.decrementItem(item);
    }
  }
</script>

<div class="flex items-center gap-3">
  {#if item.image}
    <img
      src={item.image}
      alt={item.name}
      width={40}
      height={40}
      class="rounded-sm object-cover"
    />
  {/if}
  <div class="flex flex-col flex-1">
    <p class="text-sm font-medium">{item.name || "Unnamed Item"}</p>
    <p class="text-sm text-gray-500">
      {Intl.NumberFormat("en-US", {
        style: "currency",
        currency: cart.currency,
      }).format(Number(item.unitAmount) || 0) || "0.00"}
    </p>
  </div>
  <div class="flex items-center gap-2">
    <Button
      size="iconXs"
      class="rounded-full"
      variant={isUnitOne ? "destructive" : "outline"}
      onclick={handleDecreaseClick}
    >
      {#if isUnitOne}
        <Trash2 size={16} />
      {:else}
        <Minus size={16} />
      {/if}
    </Button>
    <span class="text-sm">{itemUnits}</span>
    <Button
      class="rounded-full"
      size="iconXs"
      variant="outline"
      onclick={() => cart.actions.incrementItem(item)}
    >
      <Plus size={16} />
    </Button>
  </div>
</div>
